exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.interface[data-v-e17787f8] {\n  padding: 20px 10px;\n  border: 1px solid #FE2B41;\n  border-radius: 4px;\n  background-color: #ffffff;\n}\n.error[data-v-e17787f8] {\n  color: #FE2B41;\n  font-weight: bold;\n}\n.warning[data-v-e17787f8] {\n  color: #F1A5AC;\n  font-weight: bold;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e17787f8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/display/migration/sqwiz/Interface.vue
// module id = PSOv
// module chunks = 53